import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { WheelGamePage } from '@bcraft-frontend-lib/wheel'
import block from 'bem-cn'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'

import { selectIsUserAuthenticated, selectUserCurrrency } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'
import { selectLanguage } from 'features/userSettings/selectors'

import { useModalContext } from 'components/HOC/withModalQuery/ModalContext'

import '@bcraft-frontend-lib/wheel/lib/style.css'
import './WheelGame.scss'

const b = block('wheel-game')

export const WheelGame = () => {
  const { pushNewModal } = useModalContext()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).wheelGame
  const userCurrency = useSelector(selectUserCurrrency, shallowEqual)
  const lang = useSelector(selectLanguage, shallowEqual)

  const notAuthCallback = () => {
    pushNewModal(MODAL_ROUTE_URLS.SIGN_IN())()
  }

  return (
    <div className="wheel">
      <WheelGamePage
        isAuth={isAuth}
        locale={locale}
        currentLanguage={lang}
        userCurrency={userCurrency}
        classNames={{ wheelGamePage: b() }}
        colors={{
          megaWin: {
            bgFrom: '#260422',
            bgTo: '#65325f',
          },
        }}
        notAuthCallback={notAuthCallback}
      />
    </div>
  )
}
